// src/components/about/AboutPage.tsx
import { useEffect } from 'react';

import Footer from '../Footer';
import ProfessionalHero from './ProfessionalHero';
import ExperienceDomains from './ExperienceDomains';
import EngineeringApproach from './EngineeringApproach';
import TechnicalCapabilities from './TechnicalCapabilities';
import ExperienceTimeline from './ExperienceTimeline';
import ClientCta from './ClientCta';
import { AboutRoot } from './AboutPage.styles';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AboutRoot id="about">
        <ProfessionalHero />
        <ExperienceDomains />
        <EngineeringApproach />
        <TechnicalCapabilities />
        <ExperienceTimeline />
        <ClientCta />
      </AboutRoot>
      <Footer />
    </>
  );
};

export default AboutPage;
